import Selector from '../../../../../components/selector';
import {Button, Form, Icon} from 'antd';
import React, {useEffect, useState} from 'react';
import {MODAL_WIDTH_LG, MODAL_WIDTH_SM} from '../../../../../styles/constants';
import {translate} from 'react-i18next';
import Call from '../../../../../hocs/call';
import FileMappingForm from '../../../../../components/file-mapping-form';
import SequenceMappingForm from '../../../../../components/file-mapping-sequence-mapping-form';
import {
  hideLoaderCsvFormMappingControlDetailMapping,
  hideLoaderCsvFormMappingControlDetailSequenceMapping,
  hideLoaderCsvFormMappingControlMappings,
  hideLoaderCsvFormMappingControlSelectedMapping,
  readLoaderCsvFormMappingControlCodelistCodesItemsPage,
  readLoaderCsvFormMappingControlDetailMapping,
  readLoaderCsvFormMappingControlDetailMappingCube,
  readLoaderCsvFormMappingControlDetailSequenceMapping,
  readLoaderCsvFormMappingControlMappings,
  readLoaderCsvFormMappingControlSelectedMapping,
  readLoaderCsvFormMappingControlSelectedMappingCube,
  readLoaderCsvFormMappingControlSelectedSequenceMapping,
  setLoaderCsvFormMappingControlMapping,
  setLoaderCsvFormMappingControlMappingModified,
  setLoaderCsvFormMappingControlSequenceMapping,
  showLoaderCsvFormMappingControlDetailMapping,
  showLoaderCsvFormMappingControlDetailSequenceMapping,
  showLoaderCsvFormMappingControlMappings,
  showLoaderCsvFormMappingControlSelectedMapping,
  unsetLoaderCsvFormMappingControlMapping,
  updateLoaderCsvFormMappingControlMapping
} from './actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import EnhancedModal from '../../../../../components/enhanced-modal';
import EnhancedTree from "../../../../../components/enhanced-tree";
import {getNodes} from "../../../../../utils/tree";
import {getLocalizedStr} from "../../../../../middlewares/i18n/utils";
import {BUTTON_DETAIL} from "../../../../../styles/buttons";
import { getSequenceMappingMappings } from '../../../file-mapping/list/utils';
import { mappingHasFixedComponent } from '../../../file-mapping/wizard/utils';
import _ from 'lodash';

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const mapStateToProps = state => ({
  selectedMappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
  selectedMapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
  selectedMappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
  isSelectedMappingVisible: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isSelectedMappingVisible,
  isMappingsVisible: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isMappingsVisible,
  mappingsTree: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.mappingsTree,
  detailMappingId: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingId,
  detailMapping: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMapping,
  detailMappingCube: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingCube,
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  detailSequenceMappingId: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailSequenceMappingId,
  detailSequenceMapping: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailSequenceMapping,
  selectedMappingIsSequence: state.scenes.dataManager.loader.components.csvForm.shared.selectedMappingIsSequence,
  componentCodelistCodesItemsPage: state.scenes.dataManager.loader.components.csvForm.shared.componentCodelistCodesItemsPage,
  componentCodelistCodesItemsCount: state.scenes.dataManager.loader.components.csvForm.shared.componentCodelistCodesItemsCount,
  mappingIsModified: state.scenes.dataManager.loader.components.csvForm.shared.mappingIsModified,
});

const mapDispatchToProps = dispatch => ({
  onMappingSet: mappingId => dispatch(setLoaderCsvFormMappingControlMapping(mappingId)),
  onMappingUnset: () => dispatch(unsetLoaderCsvFormMappingControlMapping()),
  onMappingsShow: () => dispatch(showLoaderCsvFormMappingControlMappings()),
  onDetailMappingShow: mappingId => dispatch(showLoaderCsvFormMappingControlDetailMapping(mappingId)),
  onSelectedMappingShow: () => dispatch(showLoaderCsvFormMappingControlSelectedMapping()),
  onMappingsHide: () => dispatch(hideLoaderCsvFormMappingControlMappings()),
  onDetailMappingHide: () => dispatch(hideLoaderCsvFormMappingControlDetailMapping()),
  onSelectedMappingHide: () => dispatch(hideLoaderCsvFormMappingControlSelectedMapping()),
  fetchMappings: ({format, pluginId, sequenceMappingEnabled}) => dispatch(readLoaderCsvFormMappingControlMappings(format, pluginId, sequenceMappingEnabled)),
  fetchDetailMapping: mappingId => dispatch(readLoaderCsvFormMappingControlDetailMapping(mappingId)),
  fetchDetailMappingCube: cubeId => dispatch(readLoaderCsvFormMappingControlDetailMappingCube(cubeId)),
  fetchSelectedMapping: mappingId => dispatch(readLoaderCsvFormMappingControlSelectedMapping(mappingId)),
  fetchSelectedMappingCube: cubeId => dispatch(readLoaderCsvFormMappingControlSelectedMappingCube(cubeId)),
  onSequenceMappingSet: (sequenceMappingId) => dispatch(setLoaderCsvFormMappingControlSequenceMapping(sequenceMappingId)),
  onDetailSequenceMappingShow: sequenceMappingId => dispatch(showLoaderCsvFormMappingControlDetailSequenceMapping(sequenceMappingId)),
  onDetailSequenceMappingHide: () => dispatch(hideLoaderCsvFormMappingControlDetailSequenceMapping()),
  fetchDetailSequenceMapping: sequenceMappingId => dispatch(readLoaderCsvFormMappingControlDetailSequenceMapping(sequenceMappingId)),
  fetchSelectedSequenceMapping: ({selectedMappingId, mappingsTree}) => dispatch(readLoaderCsvFormMappingControlSelectedSequenceMapping(selectedMappingId, mappingsTree)),
  fetchCodelistCodesItemsPage: ({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc,
    componentName
  }) => dispatch(readLoaderCsvFormMappingControlCodelistCodesItemsPage({
      codelistTriplet,
      language,
      pageNum,
      pageSize,
      searchText,
      filters,
      sortCol,
      sortByDesc,
      componentName
    })),  
  onMappingUpdate: (mapping) => dispatch(updateLoaderCsvFormMappingControlMapping(mapping)),
  onSetMappingIsModified: (value) => dispatch(setLoaderCsvFormMappingControlMappingModified(value))
});

const LoaderCsvFormMappingControl = ({
                                       t,
                                       form,
                                       format,
                                       pluginId,
                                       appLanguage,
                                       dataLanguages,
                                       selectedMappingId,
                                       selectedMapping,
                                       selectedMappingCube,
                                       isSelectedMappingVisible,
                                       isMappingsVisible,
                                       mappingsTree,
                                       detailMappingId,                                       
                                       detailMapping,
                                       detailMappingCube,                                    
                                       detailSequenceMappingId,
                                       detailSequenceMapping,
                                       selectedMappingIsSequence,
                                       onMappingSet,
                                       onMappingUnset,
                                       onMappingsShow,
                                       onDetailMappingShow,
                                       onSelectedMappingShow,
                                       onMappingsHide,
                                       onDetailMappingHide,
                                       onSelectedMappingHide,
                                       fetchMappings,
                                       sequenceMappingEnabled,
                                       fetchDetailMapping,
                                       fetchDetailMappingCube,
                                       fetchSelectedMapping,
                                       fetchSelectedMappingCube,
                                       onSequenceMappingSet,
                                       onDetailSequenceMappingShow,
                                       onDetailSequenceMappingHide,
                                       fetchDetailSequenceMapping,
                                       fetchSelectedSequenceMapping,
                                       fetchCodelistCodesItemsPage,
                                       componentCodelistCodesItemsPage,
                                       componentCodelistCodesItemsCount,
                                       onMappingUpdate,
                                       mappingIsModified,
                                       onSetMappingIsModified
                                     }) => {

  const [selected, setSelected] = useState(null);
  const [tempFileMapping, setTempFileMapping] = useState(null);

  useEffect(() => {
    if (selectedMapping !== null) {
      setTempFileMapping(selectedMapping);
    }
  }, [selectedMapping]);

  const onHideSelectedMapping = () => {
    setTempFileMapping(selectedMapping);
    onSelectedMappingHide();
    onSetMappingIsModified(false);
  }
  
  const onModifyMappingFixedValue = (componentName, value) => {
    const modifiedMapping = _.cloneDeep(tempFileMapping);
    const component =  modifiedMapping.Components.find(c => c.CubeComponentCode === componentName);
    component.Expression.basicExp = [`'${value}'`];
    setTempFileMapping(modifiedMapping); 
    onSetMappingIsModified(true);              
  }

  const onUpdateMapping = () => {
    onSelectedMappingHide();
    onMappingUpdate(tempFileMapping);
  }
  

  return (
    <Call 
      cb={fetchSelectedMapping} 
      cbParam={selectedMappingId}
      disabled={selectedMappingId === null || selectedMappingIsSequence}
    >
      <Call
        cb={fetchSelectedSequenceMapping} 
        cbParam={{selectedMappingId, mappingsTree}}
        disabled={selectedMappingId === null || !selectedMappingIsSequence }
      >
        <Call
          cb={fetchSelectedMappingCube}
          cbParam={selectedMapping !== null && selectedMapping.IDCube}
          disabled={selectedMapping === null}
        >
         
          {(selectedMapping && !selectedMappingIsSequence)  && (
            <EnhancedModal
              visible={isSelectedMappingVisible}
              onCancel={() => onHideSelectedMapping()}
              title={t('scenes.dataManager.loader.csvForm.mappingControl.selectedMapping.title')}
              width={MODAL_WIDTH_SM}
              footer={
                <div>
                  <Button onClick={() => onHideSelectedMapping()}>
                    {t('commons.buttons.close.title')}
                  </Button>
                  {mappingHasFixedComponent(selectedMapping) && (
                    <Button
                      onClick={() => onUpdateMapping()}
                      type="primary"
                      disabled={!mappingIsModified}
                    >
                      {t('commons.buttons.save.title')}
                    </Button>
                  )}
              </div>}
            >
              <FileMappingForm 
                fileMapping={tempFileMapping} 
                cube={selectedMappingCube}
                appLanguage={appLanguage}
                fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
                componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
                componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
                editFixedComponent
                onModifyMappingFixedValue={onModifyMappingFixedValue}          
              />                         
            </EnhancedModal>
          )}

          {(selectedMapping && selectedMappingIsSequence)  && ( 
            <EnhancedModal
              visible={isSelectedMappingVisible }
              onCancel={onSelectedMappingHide}
              title={t('scenes.dataManager.loader.csvForm.mappingControl.selectedMapping.title')}
              width={MODAL_WIDTH_SM}
              footer={
                <Button
                  onClick={onSelectedMappingHide}>{t('commons.buttons.close.title')}
                </Button>}            
            >
              <SequenceMappingForm 
                sequenceMapping={selectedMapping} 
                cube={selectedMappingCube}
                components={(mappingsTree) ?
                  getSequenceMappingMappings(selectedMapping, mappingsTree)
                  : []}
              />            
            </EnhancedModal>
          )}
          
          <EnhancedModal
            visible={isMappingsVisible}
            onCancel={onMappingsHide}
            title={t('scenes.dataManager.loader.csvForm.mappingControl.mappingList.title')}
            width={MODAL_WIDTH_LG}
            footer={
              <div>
                <Button onClick={() => {
                  onMappingsHide();
                  setSelected(null);
                }}
                >
                  {t('commons.buttons.close.title')}
                </Button>
                <Button
                  onClick={() => {
                    if (selected.startsWith("Mapp_")) {
                      onMappingSet(Number(selected.replace("Mapp_", "")));
                    } else {
                      onSequenceMappingSet(Number(selected.replace("SeqMapp_", "")))
                    }
                    setSelected(null);                      
                    }} 
                  type="primary"
                  disabled={!selected}
                >
                  {t('commons.buttons.select.title')}
                </Button>
              </div>
            }
          >
            <Call 
              cb={fetchMappings}
              cbParam={{format, pluginId, sequenceMappingEnabled}}
            >
              <div className="loader__csv-form__tree">
                <EnhancedTree
                  tree={mappingsTree}
                  idKey="TreeID"
                  nameKey="Name"
                  childrenKey="children"
                  catIdKey="TreeID"
                  catNameKey="labels"
                  getIsNameMultilanguage={node => !node.IDMapping && !node.IDSeqMapping}
                  unselectableKeys={
                    getNodes(mappingsTree, 'children', (node => 
                      {
                        if (format !== 'plugin') {
                          return !node.IDMapping || !!node.IDSeqMapping
                        } else {
                          return !(node.IDMapping || (sequenceMappingEnabled && node.IDSeqMapping))
                        }
                      }))
                      .map(node => node.TreeID)
                  }
                  hiddenIdKeys={
                    getNodes(mappingsTree, 'children', (({Code}) => !Code))
                      .map(node => node.TreeID)
                  }
                  getIcon={({Code, IDMapping, XMLFilePath, IDSeqMapping,IconName, IconColor, PluginId}) => {
                    if (Code) {
                      return (
                        <IconFontCNIcon
                          theme="filled"
                          style={{color: "#37a0f4"}}
                          type="cube"
                        />
                      );
                    } else if (IDMapping) {
                      if(PluginId && IconName){
                        return (
                          <Icon
                            theme="outlined"
                            type={!!IconName ? IconName : "file-text"}
                            style={{color: !!IconColor ? _.lowerCase(IconColor.replaceAll('_','')) : "grey"}}
                          />
                        );
                      }
                      else if (XMLFilePath && !PluginId) {
                        return (
                          <Icon
                            theme="outlined"
                            type="file-excel"
                            style={{color: "green"}}
                          />
                        );
                      } else {
                        return (
                          <Icon
                            theme="outlined"
                            type="file-text"
                          />
                        );
                      }
                    } else if (IDSeqMapping) {
                      return (
                        <Icon
                          theme="outlined"
                          type={!!IconName ? IconName : "file-excel"}
                          style={{color: !!IconColor ? _.lowerCase(IconColor.replaceAll('_',''))  : "blue"}}
                        />
                      );
                    } else {
                      return null;
                    }
                  }}
                  getFilter={
                    searchText =>
                      ({labels, Code, Name}) => {
                        const search = searchText.toLowerCase();
                        return (Name && Name.toLowerCase()
                            .indexOf(search) >= 0) ||
                          (Code && Code.toLowerCase()
                            .indexOf(search) >= 0) ||
                          (labels && getLocalizedStr(labels, appLanguage, dataLanguages)
                            .toLowerCase()
                            .indexOf(search) >= 0);
                      }
                  }
                  onSelect={selectedArr => {
                    if (selectedArr && selectedArr[0]) {
                      setSelected(selectedArr[0])
                    } else {
                      setSelected(null);
                    }
                  }}
                  treeActions={[
                    {
                      title: t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),
                      icon: 'sync',
                      onClick: () => fetchMappings({format, pluginId, sequenceMappingEnabled})
                    }
                  ]}
                  actions={
                    (() => {                 
                      if (selected && (selected.startsWith("Mapp_") || selected.startsWith("SeqMapp_"))) {                       
                        let id;
                        const isMapping = selected.startsWith("Mapp_");
                        if (isMapping) {
                          id = Number(selected.replace("Mapp_", ""));
                        } else {
                          id = Number(selected.replace("SeqMapp_", ""));
                        }
                        return [
                          {
                            ...BUTTON_DETAIL,
                            title: t('components.itemList.actions.view.title'),
                            onClick: () => {
                              if (isMapping) {
                                onDetailMappingShow(id);
                              } else {
                                onDetailSequenceMappingShow(id);
                              }                      
                            }
                          },                      
                        ];
                      } else {
                        return null;
                      }
                    })()
                  }
                />
              </div>
            </Call>
          </EnhancedModal>

          <EnhancedModal
            visible={detailMappingId !== null}
            onCancel={onDetailMappingHide}
            title={t('scenes.dataManager.loader.csvForm.mappingControl.detailMapping.title')}
            width={MODAL_WIDTH_SM}
            footer={<Button onClick={onDetailMappingHide}>{t('commons.buttons.close.title')}</Button>}
          >
            <Call cb={fetchDetailMapping} cbParam={detailMappingId}>
              <Call
                cb={fetchDetailMappingCube}
                cbParam={detailMapping !== null && detailMapping.IDCube}
                disabled={detailMapping === null}
              >
                <FileMappingForm 
                  fileMapping={detailMapping} 
                  cube={detailMappingCube}
                  />
              </Call>
            </Call>
          </EnhancedModal>

          <EnhancedModal
            visible={detailSequenceMappingId !== null}
            onCancel={onDetailSequenceMappingHide}
            title={t('scenes.dataManager.loader.csvForm.mappingControl.detailSequenceMapping.title')}
            width={MODAL_WIDTH_SM}
            footer={<Button onClick={onDetailSequenceMappingHide}>{t('commons.buttons.close.title')}</Button>}
          >
            <Call cb={fetchDetailSequenceMapping} cbParam={detailSequenceMappingId}>
              <Call
                cb={fetchDetailMappingCube}
                cbParam={detailSequenceMapping !== null && detailSequenceMapping.IDCube}
                disabled={detailSequenceMapping === null}
              >
                <SequenceMappingForm 
                  sequenceMapping={detailSequenceMapping} 
                  cube={detailMappingCube}
                  components={(detailSequenceMapping  && mappingsTree) ?
                    getSequenceMappingMappings(detailSequenceMapping, mappingsTree)
                  : []}
                />
              </Call>
            </Call>
          </EnhancedModal>
          
          <Form.Item>
            {form.getFieldDecorator('mappingId')(
              <Selector
                detailTitle={t('scenes.dataManager.loader.csvForm.mappingControl.detailIcon.title')}
                selectTitle={t('scenes.dataManager.loader.csvForm.mappingControl.selectIcon.title')}
                resetTitle={t('scenes.dataManager.loader.csvForm.mappingControl.resetIcon.title')}
                onDetail={onSelectedMappingShow}
                onSelect={onMappingsShow}
                onReset={onMappingUnset}
              />
            )}
          </Form.Item>
          
        </Call>
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(LoaderCsvFormMappingControl);
